// Conversation status — PATCH /api/conversations/:id { status }.
// The Agent Workspace UI uses lower-case values (open/pending/escalated/closed); the API uses Title Case.
import { setConversationStatus } from "../api/services/conversationService";

const TO_API = { open: "Open", pending: "Pending", escalated: "Escalated", closed: "Closed" };

export const updateConversationStatus = async (conversationId, status) => {
  if (!conversationId || !TO_API[status]) throw new Error("Invalid status data");
  const updated = await setConversationStatus(conversationId, TO_API[status]);
  return { success: true, data: { conversationId, status: updated.status.toLowerCase() === "resolved" ? "closed" : updated.status.toLowerCase() } };
};
